module.exports = __webpack_public_path__ + "img/messenger-instruction-4.f119cca8.png";